import { MarkSpec } from 'prosemirror-model';
import { marks } from 'ngx-editor';

export const InputRichTextMarks: object = {
  ...marks,
  sup: {
    excludes: 'sub',
    parseDOM: [{ tag: 'sup' }],
    toDOM: () => ['sup', 0],
  },
  sub: {
    excludes: 'sup',
    parseDOM: [{ tag: 'sub' }],
    toDOM: () => ['sub', 0],
  },
  font_size: {
    attrs: { size: { default: '11pt' } },
    parseDOM: [
      {
        style: 'font-size',
        getAttrs: (value: string) => ({ size: value }),
      },
    ],
    toDOM: (mark: MarkSpec) => ['span', { style: `font-size: ${mark.attrs.size}` }, 0],
  },
  font_family: {
    attrs: { family: { default: 'Calibri' } },
    parseDOM: [
      {
        style: 'font-family',
        getAttrs: (value: string) => ({ family: value }),
      },
    ],
    toDOM: (mark: MarkSpec) => ['span', { style: `font-family: ${mark.attrs.family}` }, 0],
  },
  text_background_color: {
    ...marks.text_background_color,
    parseDOM: [
      ...marks.text_background_color.parseDOM,
      {
        style: 'background',
        getAttrs: (value: string) => ({ backgroundColor: value }),
      },
    ],
  },
};
